import React, { PureComponent } from 'react';

import { Grid, Cell } from 'formlabs-web-components/Grid';
import { DisplayComponent } from 'formlabs-web-components/BaseComponents';

import TextPlugin from '../../../../common/components/cms/TextPlugin';

const LegacyBlogContent = DisplayComponent(
  class LegacyBlogContent extends PureComponent {
    render() {
      const { content, children, classes } = this.props;

      return (
        <Grid direction="x" className={classes}>
          <Cell mediumSize={24}>
            <TextPlugin body={content}>{children}</TextPlugin>
          </Cell>
        </Grid>
      );
    }
  }
);

LegacyBlogContent.propTypes = {};

export default LegacyBlogContent;
